import React from 'react';
import classnames from 'classnames';
import DeviationDumbView from '../../../../DeviationViews/Dumbo';
import { DeviationLink } from '../../../../Duperbrowse';
import { isImageDeviation } from '../../../../DeviationViews/_helpers';
import DeviationImageCoverView from './DeviationImageCoverView';
import { SLIDESHOW_HEIGHT } from './DeviationSlideshow';
import s from './DeviationSlideshow.scss';
const Slide = ({ deviation, containerWidth, useCoverMode, active = true, visible = true })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['slide'], active && s['active']),
        title: deviation.title,
        style: {
            height: SLIDESHOW_HEIGHT,
            visibility: visible ? 'visible' : 'hidden'
        }
    }, useCoverMode && isImageDeviation(deviation) ? /*#__PURE__*/ React.createElement(DeviationImageCoverView, {
        className: s['deviation'],
        deviation: deviation,
        containerWidth: containerWidth,
        containerHeight: SLIDESHOW_HEIGHT
    }) : /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['deviation'],
        deviation: deviation,
        width: containerWidth,
        height: SLIDESHOW_HEIGHT,
        noCropping: true
    }), /*#__PURE__*/ React.createElement(DeviationLink, {
        className: s['deviation-link'],
        deviation: deviation,
        title: deviation.title
    }));
export default /*#__PURE__*/ React.memo(Slide);

//# sourceMappingURL=Slide.js.map